<div class="app-sidebar__overlay" data-toggle="sidebar"></div>
<aside class="app-sidebar">
  <div class="app-sidebar__user"><img width="48" height="48" class="app-sidebar__user-avatar" src="{{photoUrl}}"
      alt="User Image">
    <div>
      <p class="app-sidebar__user-name">{{loginUserData.StudentNumber}}</p>
      <p class="app-sidebar__user-designation">{{loginUserData.ApplicationType}}</p>
    </div>
  </div>
  <ul class="app-menu">
    <li><a class="app-menu__item" [routerLink]="[ '/applicant/dashboard' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-dashboard"></i><span class="app-menu__label">Dashboard</span></a></li>

    <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/notices' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-sticky-note-o"></i><span class="app-menu__label">Instruction</span></a></li>
    <li><a class="app-menu__item" [routerLink]="[ '/applicant/choose-campus' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-map-marker"></i><span class="app-menu__label">Choose Campus</span></a></li>

    <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/upload-image' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-user-circle-o"></i><span class="app-menu__label">Upload Image</span></a></li>
    <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/personal/basic' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-edit"></i><span class="app-menu__label">Personal Info</span></a></li>
    <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/personal/contact' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-phone"></i><span class="app-menu__label">Contact Info</span></a></li>
    <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/personal/guardian' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-edit"></i><span class="app-menu__label">Parent/Guardian's Info</span></a></li>
    <div *ngIf="!isPostgraduateStudent()">
      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/exam-info' ]" routerLinkActive="active"><i
            class="app-menu__icon fa fa-pie-chart"></i><span class="app-menu__label">Examination</span></a></li>

      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/programme-selection' ]"
          routerLinkActive="active"><i class="app-menu__icon fa fa-th-list"></i><span class="app-menu__label">Choose
            Programme</span></a></li>


    </div>

    <div *ngIf="isPostgraduateStudent()">
      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/post-univ' ]" routerLinkActive="active">
          <i class="app-menu__icon fa fa-university">

          </i><span class="app-menu__label">High Educational Hist.</span></a></li>


      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/post-high-school' ]" routerLinkActive="active">
          <i class="app-menu__icon fa fa-archive"></i><span class="app-menu__label">Institution Attended</span></a>
      </li>

      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/post-work-experience' ]" routerLinkActive="active">
          <i class="app-menu__icon fa fa-lightbulb-o"></i><span class="app-menu__label">Work Experience</span></a></li>

      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/post-certificate' ]" routerLinkActive="active">
          <i class="app-menu__icon fa fa-delicious"></i><span class="app-menu__label">Relevant Short
            Course(s)</span></a></li>
      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/post-research' ]" routerLinkActive="active">
          <i class="app-menu__icon fa newspaper-o"></i><span class="app-menu__label">Journal/Conference</span></a></li>
      <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/post-programme' ]" routerLinkActive="active"><i
            class="app-menu__icon fa fa-th-list"></i><span class="app-menu__label">Choose Programme</span></a></li>

    </div>

    <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/documents' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-book"></i><span class="app-menu__label">Upload Document</span></a></li>
    <li><a class="app-menu__item" [routerLink]="[ '/applicant/info/application-summary' ]" routerLinkActive="active"><i
          class="app-menu__icon fa fa-file-text"></i><span class="app-menu__label">Summary</span></a></li>
    <li><a class="app-menu__item" href="#" (click)="onLogOut($event)"><i class="app-menu__icon fa fa-sign-out"></i><span
          class="app-menu__label">Logout</span></a></li>

  </ul>
</aside>